<template>
  <div class="hpText">
xxxx
      <div class="hptFlexEl">
        <svg viewBox="1.0822 0.119 374.7805 56.5725" xmlns="http://www.w3.org/2000/svg">
        <g transform="matrix(0.5006420016288757, 0, 0, 0.5006420016288757, -253.84474182128906, -186.0697479248047)"  >

          <g>
            <g>
              <path class="cls-1" d="M667.3,443.5h-54.9s0-5.5,0-5.5h54.8c5.4,0,9.8-4,9.8-8.9s-3.3-7.9-7.8-8.8c-1.3-.3-2.7-.6-4.4-.9,0,0-4.1-.4-15-1.7-9-1-13.6-1.4-25-2.8-1.7-.2-2.5-.3-4.5-.8-2.3-.5-3.9-1.4-5.8-2.7-2.1-1.5-2.4-3.6-2.4-6.1,0-5,3.9-9.2,8.9-9.2h20.4v5.5c-7.5,0-11.2,0-19.2,0-2.1,0-3.8,1.6-3.8,3.7s.9,2.7,2.4,3.3c1.4,.5,6.9,1.1,9,1.4,1.5,.3,20,2.3,20,2.3,0,0,18.1,2.2,19.4,2.4,8.1,1,13.7,6.9,13.7,14.4s-6.7,14.5-15,14.5h-.6s0,0,0,0Z" style="fill: rgb(0, 110, 184); fill-rule: evenodd;"/>
              <path class="cls-1" d="M667.3,443.5h-54.9s0-5.5,0-5.5h54.8c5.4,0,9.8-4,9.8-8.9s-3.3-7.9-7.8-8.8c-1.3-.3-2.7-.6-4.4-.9,0,0-4.1-.4-15-1.7-9-1-13.6-1.4-25-2.8-1.7-.2-2.5-.3-4.5-.8-2.3-.5-3.9-1.4-5.8-2.7-2.1-1.5-2.4-3.6-2.4-6.1,0-5,3.9-9.2,8.9-9.2h20.4v5.5c-7.5,0-11.2,0-19.2,0-2.1,0-3.8,1.6-3.8,3.7s.9,2.7,2.4,3.3c1.4,.5,6.9,1.1,9,1.4,1.5,.3,20,2.3,20,2.3,0,0,18.1,2.2,19.4,2.4,8.1,1,13.7,6.9,13.7,14.4s-6.7,14.5-15,14.5h-.6s0,0,0,0Z" style="fill: rgb(0, 110, 184); fill-rule: evenodd;"/>
              <rect class="cls-2" x="597.4" y="371.9" width="5.5" height="18.2" style="fill: rgb(0, 110, 184);"/>
              <rect class="cls-2" x="597.4" y="396.1" width="5.6" height="47.7" style="fill: rgb(0, 110, 184);"/>
              <rect class="cls-2" x="597.4" y="371.9" width="5.5" height="18.2" style="fill: rgb(0, 110, 184);"/>
              <rect class="cls-2" x="597.4" y="396.1" width="5.6" height="47.7" style="fill: rgb(0, 110, 184);"/>
              <path class="cls-1" d="M552.3,444h-5.6s0-39.6,0-39.6c0-1.1-.4-2.3-1.3-2.9-.7-.5-1.6-.6-2.2-.6-1,0-1.8,0-3.5,2.6l-23.6,40.4h-6.8s5.7-9.9,5.7-9.9c2.2-2.6,17.9-30.5,17.9-30.5,3-4.8,5.2-7.5,8.8-7.7,1.3,0,1.9-.2,3.2,0,1.9,.2,2.8,.7,4,1.6,1,.7,1.7,1.6,2.3,2.7,.7,1.2,1,2.5,1,3.9,0,12.7,0,17.4,0,28.4,4.1-6.4,16.8-29,16.8-29,3-4.8,5.2-7.5,8.8-7.7,1.3,0,1.9-.2,3.2,0,1.9,.2,2.7,.7,4,1.6,1,.7,1.7,1.6,2.3,2.7,.7,1.2,1,2.5,1,3.9,0,15.5,0,24.2,0,39.7h-5.6v-39.4c0-1.1-.4-2.3-1.3-2.9-.7-.5-1.6-.6-2.2-.6-1,0-1.8,0-3.5,2.6l-23.6,40.4Z" style="fill: rgb(0, 110, 184); fill-rule: evenodd;"/>
            </g>
            <path class="cls-2" d="M648.7,394.2c.8,0,1.5,.2,2.3,.6,.7,.4,1.3,1,1.7,1.7s.6,1.5,.6,2.3-.2,1.6-.6,2.3c-.4,.7-1,1.3-1.7,1.7-.7,.4-1.5,.6-2.3,.6s-1.6-.2-2.3-.6c-.7-.4-1.3-1-1.7-1.7-.4-.7-.6-1.5-.6-2.3s.2-1.6,.6-2.3c.4-.7,1-1.3,1.7-1.7,.7-.4,1.5-.6,2.3-.6Zm0,.8c-.7,0-1.3,.2-1.9,.5s-1.1,.8-1.5,1.4c-.4,.6-.5,1.3-.5,1.9s.2,1.3,.5,1.9c.3,.6,.8,1.1,1.4,1.4,.6,.3,1.3,.5,1.9,.5s1.3-.2,1.9-.5c.6-.3,1.1-.8,1.4-1.4,.3-.6,.5-1.3,.5-1.9s-.2-1.3-.5-1.9c-.3-.6-.8-1.1-1.5-1.4s-1.3-.5-1.9-.5Zm-2,6.5v-5h1.7c.6,0,1,0,1.3,.1,.3,0,.5,.3,.6,.5s.2,.5,.2,.7-.1,.7-.4,1c-.3,.3-.6,.4-1,.5,.2,0,.3,.2,.4,.3,.2,.2,.4,.5,.7,1l.6,1h-1l-.4-.8c-.4-.6-.6-1-.8-1.2-.1-.1-.4-.2-.6-.2h-.5v2.1h-.8Zm.8-2.8h1c.5,0,.8,0,1-.2,.2-.1,.3-.3,.3-.6s0-.3-.1-.4c0-.1-.2-.2-.3-.3-.1,0-.4,0-.8,0h-.9v1.5Z" style="fill: rgb(0, 110, 184);"/>
          </g>

          <!-- MAKE IT SIMPLE -->
          <g>
            <path class="cls-2" d="M723.2,444.6v-48h9.6l11.4,34c1,3.2,1.8,5.5,2.3,7.1,.5-1.7,1.4-4.3,2.6-7.7l11.5-33.4h8.5v48h-6.1v-40.2l-14,40.2h-5.7l-13.9-40.9v40.9h-6.1Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M774.8,444.6l18.4-48h6.8l19.7,48h-7.2l-5.6-14.5h-20.1l-5.3,14.5h-6.7Zm13.9-19.7h16.3l-5-13.3c-1.5-4-2.7-7.4-3.4-10-.6,3.1-1.5,6.1-2.6,9.2l-5.3,14.1Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M825.2,444.6v-48h6.4v23.8l23.8-23.8h8.6l-20.1,19.5,21,28.6h-8.4l-17.1-24.3-7.9,7.7v16.6h-6.4Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M871.1,444.6v-48h34.7v5.7h-28.4v14.7h26.6v5.6h-26.6v16.3h29.5v5.7h-35.8Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M936.9,444.6v-48h6.4v48h-6.4Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M967.4,444.6v-42.3h-15.8v-5.7h38.1v5.7h-15.9v42.3h-6.4Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M1012.9,429.2l6-.5c.3,2.4,.9,4.4,2,5.9,1,1.5,2.6,2.8,4.8,3.7,2.2,.9,4.6,1.4,7.4,1.4s4.6-.4,6.4-1.1c1.9-.7,3.2-1.7,4.1-3,.9-1.3,1.4-2.6,1.4-4.1s-.4-2.8-1.3-3.9c-.9-1.1-2.3-2.1-4.3-2.8-1.3-.5-4.1-1.3-8.5-2.3-4.4-1.1-7.5-2.1-9.3-3-2.3-1.2-4-2.7-5.1-4.5-1.1-1.8-1.7-3.8-1.7-6s.7-4.7,2.1-6.8c1.4-2.1,3.4-3.7,6-4.8,2.6-1.1,5.6-1.6,8.8-1.6s6.7,.6,9.4,1.7c2.7,1.1,4.8,2.8,6.3,5.1,1.5,2.2,2.2,4.7,2.4,7.6l-6.1,.5c-.3-3-1.4-5.3-3.3-6.9-1.9-1.5-4.7-2.3-8.4-2.3s-6.6,.7-8.4,2.1-2.6,3.1-2.6,5.1,.6,3.1,1.9,4.3c1.2,1.1,4.4,2.3,9.6,3.4,5.2,1.2,8.7,2.2,10.6,3.1,2.8,1.3,4.9,2.9,6.2,4.9s2,4.3,2,6.8-.7,5-2.2,7.2-3.6,4-6.3,5.3-5.8,1.9-9.3,1.9-8-.6-10.9-1.9c-2.9-1.3-5.2-3.2-6.9-5.7s-2.5-5.4-2.6-8.6Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M1061.6,444.6v-48h6.4v48h-6.4Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M1079.7,444.6v-48h9.6l11.4,34c1,3.2,1.8,5.5,2.3,7.1,.5-1.7,1.4-4.3,2.6-7.7l11.5-33.4h8.5v48h-6.1v-40.2l-14,40.2h-5.7l-13.9-40.9v40.9h-6.1Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M1136.5,444.6v-48h18.1c3.2,0,5.6,.2,7.3,.5,2.4,.4,4.3,1.1,5.9,2.2,1.6,1.1,2.9,2.6,3.8,4.6s1.5,4.2,1.5,6.5c0,4.1-1.3,7.5-3.9,10.4-2.6,2.8-7.3,4.2-14.1,4.2h-12.3v19.5h-6.4Zm6.4-25.2h12.4c4.1,0,7-.8,8.7-2.3s2.6-3.7,2.6-6.5-.5-3.7-1.5-5.2c-1-1.4-2.4-2.4-4-2.8-1.1-.3-3-.4-5.9-.4h-12.3v17.2Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M1181.7,444.6v-48h6.4v42.3h23.6v5.7h-30Z" style="fill: rgb(0, 110, 184);"/>
            <path class="cls-2" d="M1220.2,444.6v-48h34.7v5.7h-28.4v14.7h26.6v5.6h-26.6v16.3h29.5v5.7h-35.8Z" style="fill: rgb(0, 110, 184);"/>
          </g>

          <line class="cls-3" x1="701.4" y1="388.5" x2="701.4" y2="452.5" style="fill: none; stroke: rgb(0, 110, 184); stroke-miterlimit: 10; stroke-width: 3px;"/>
        </g>

        <!-- OUR MISSION IS TO ... -->
        <g transform="matrix(0.5006420016288757, 0, 0, 0.5006420016288757, -253.84474182128906, -186.0697479248047)"  >
          <path style="--index:0" class="cls-4" stroke="#000000" stroke-width="1" d="M530.4,472.6c0,7.5-4.1,12.3-10.6,12.3s-10.6-4.8-10.6-12.3,4.1-12.3,10.6-12.3,10.6,4.8,10.6,12.3Zm-18.8,0c0,6.3,3.2,10.3,8.3,10.3s8.3-4,8.3-10.3-3.2-10.3-8.3-10.3-8.3,4-8.3,10.3Z" />
          <path style="--index:1" class="cls-4" stroke="#000000" stroke-width="1" d="M551.3,475.6c0,6-3,9.3-8.5,9.3s-8.5-3.2-8.5-9.3v-15h2.2v14.9c0,4.9,2.4,7.2,6.3,7.2s6.3-2.3,6.3-7.2v-14.9h2.2v15Z" />
          <path style="--index:2" class="cls-4" stroke="#000000" stroke-width="1" d="M564,460.7c5.6,0,8.2,2.4,8.2,6.3s-1.8,5.4-4.6,6h0c1.8,.6,2.5,1.6,3.5,4.5l2.5,6.9h-2.4l-2.3-6.6c-1-3-2.2-3.9-4.8-3.9h-4.9v10.5h-2.2v-23.8h7Zm-4.8,11.3h4.9c4,0,5.8-2.1,5.8-4.9,0-3-2.1-4.4-5.9-4.4h-4.8v9.4Z" />
          <path style="--index:3" class="cls-4" stroke="#000000" stroke-width="1" d="M605.4,484.5v-12.2c0-3.1,0-6.1,0-9.2h0c-1.2,3.1-2.4,6.2-3.6,9.3l-4.7,12.1h-2.5l-4.7-12.1c-1.2-3.1-2.4-6.1-3.6-9.3h0c0,3.1,0,6.1,0,9.2v12.2h-2.2v-23.8h3.5l4.7,12.2,3.5,9.3h0c1.2-3.1,2.4-6.2,3.6-9.3l4.7-12.2h3.5v23.8h-2.2Z" />
          <path style="--index:4" class="cls-4" stroke="#000000" stroke-width="1" d="M613.5,484.5v-23.8h2.2v23.8h-2.2Z" />
          <path style="--index:5" class="cls-4" stroke="#000000" stroke-width="1" d="M635.9,468.1h-2.2c0-4-2.2-5.8-6.1-5.8s-5.2,1.6-5.2,4.3,2,3.7,6,4.6c4.5,1.1,7.9,2.2,7.9,6.9s-3.1,6.8-8.1,6.8-8.5-2.8-8.5-8.4h2.2c0,4.4,2.5,6.3,6.3,6.3s5.9-1.7,5.9-4.7-2.2-3.7-6.3-4.8c-4.6-1.1-7.7-2.3-7.7-6.8s2.8-6.3,7.4-6.3,8.3,2.7,8.3,7.8Z"  />
          <path style="--index:6" class="cls-4" stroke="#000000" stroke-width="1" d="M655.1,468.1h-2.2c0-4-2.2-5.8-6.1-5.8s-5.2,1.6-5.2,4.3,2,3.7,6,4.6c4.5,1.1,7.9,2.2,7.9,6.9s-3.1,6.8-8.1,6.8-8.5-2.8-8.5-8.4h2.2c0,4.4,2.5,6.3,6.3,6.3s5.9-1.7,5.9-4.7-2.2-3.7-6.3-4.8c-4.6-1.1-7.7-2.3-7.7-6.8s2.8-6.3,7.4-6.3,8.3,2.7,8.3,7.8Z"  />
          <path style="--index:7" class="cls-4" stroke="#000000" stroke-width="1" d="M659.9,484.5v-23.8h2.2v23.8h-2.2Z" />
          <path style="--index:8" class="cls-4" stroke="#000000" stroke-width="1" d="M687.3,472.6c0,7.5-4.1,12.3-10.6,12.3s-10.6-4.8-10.6-12.3,4.1-12.3,10.6-12.3,10.6,4.8,10.6,12.3Zm-18.8,0c0,6.3,3.2,10.3,8.3,10.3s8.3-4,8.3-10.3-3.2-10.3-8.3-10.3-8.3,4-8.3,10.3Z"  />
          <path style="--index:9" class="cls-4" stroke="#000000" stroke-width="1" d="M706.2,484.5l-6.2-10.6c-2.2-3.7-4.3-7.4-6.4-11.1h0c0,4,0,7.9,0,11.9v9.7h-2.2v-23.8h3.3l6.2,10.6c2.2,3.7,4.3,7.4,6.4,11.1h0c0-4,0-7.9,0-11.9v-9.7h2.2v23.8h-3.3Z"  />
          <path style="--index:10" class="cls-4" stroke="#000000" stroke-width="1" d="M722.3,484.5v-23.8h2.2v23.8h-2.2Z" />
          <path style="--index:11" class="cls-4" stroke="#000000" stroke-width="1" d="M744.7,468.1h-2.2c0-4-2.2-5.8-6.1-5.8s-5.2,1.6-5.2,4.3,2,3.7,6,4.6c4.5,1.1,7.9,2.2,7.9,6.9s-3.1,6.8-8.1,6.8-8.5-2.8-8.5-8.4h2.2c0,4.4,2.5,6.3,6.3,6.3s5.9-1.7,5.9-4.7-2.2-3.7-6.3-4.8c-4.6-1.1-7.7-2.3-7.7-6.8s2.8-6.3,7.4-6.3,8.3,2.7,8.3,7.8Z"  />
          <path style="--index:12" class="cls-4" stroke="#000000" stroke-width="1" d="M763.9,462.6v21.8h-2.2v-21.8h-8.5v-2h19.1v2h-8.5Z" />
          <path style="--index:13" class="cls-4" stroke="#000000" stroke-width="1" d="M793.2,472.6c0,7.5-4.1,12.3-10.6,12.3s-10.6-4.8-10.6-12.3,4.1-12.3,10.6-12.3,10.6,4.8,10.6,12.3Zm-18.8,0c0,6.3,3.2,10.3,8.3,10.3s8.3-4,8.3-10.3-3.2-10.3-8.3-10.3-8.3,4-8.3,10.3Z"  />
          <path style="--index:14" class="cls-4" stroke="#000000" stroke-width="1" d="M818.5,468.1h-2.2c0-4-2.2-5.8-6.1-5.8s-5.2,1.6-5.2,4.3,2,3.7,6,4.6c4.5,1.1,7.9,2.2,7.9,6.9s-3.1,6.8-8.1,6.8-8.5-2.8-8.5-8.4h2.2c0,4.4,2.5,6.3,6.3,6.3s5.9-1.7,5.9-4.7-2.2-3.7-6.3-4.8c-4.6-1.1-7.7-2.3-7.7-6.8s2.8-6.3,7.4-6.3,8.3,2.7,8.3,7.8Z"  />
          <path style="--index:15" class="cls-4" stroke="#000000" stroke-width="1" d="M823.3,484.5v-23.8h2.2v23.8h-2.2Z" />
          <path style="--index:16" class="cls-4" stroke="#000000" stroke-width="1" d="M852.9,484.5v-12.2c0-3.1,0-6.1,0-9.2h0c-1.2,3.1-2.4,6.2-3.6,9.3l-4.7,12.1h-2.5l-4.7-12.1c-1.2-3.1-2.4-6.1-3.6-9.3h0c0,3.1,0,6.1,0,9.2v12.2h-2.2v-23.8h3.5l4.7,12.2,3.5,9.3h0c1.2-3.1,2.4-6.2,3.6-9.3l4.7-12.2h3.5v23.8h-2.2Z"  />
          <path style="--index:17" class="cls-4" stroke="#000000" stroke-width="1" d="M868.7,460.7c5.3,0,8.1,2.7,8.1,6.9s-2.8,6.9-8.1,6.9h-5.6v9.9h-2.2v-23.8h7.7Zm-5.6,11.9h5.5c3.9,0,5.9-1.9,5.9-5s-2-4.9-5.9-4.9h-5.5v9.9Z"  />
          <path style="--index:18" class="cls-4" stroke="#000000" stroke-width="1" d="M895.1,482.5v2h-14.8v-23.8h2.2v21.8h12.6Z" />
          <path style="--index:19" class="cls-4" stroke="#000000" stroke-width="1" d="M898,484.5v-23.8h2.2v23.8h-2.2Z" />
          <path style="--index:20" class="cls-4" stroke="#000000" stroke-width="1" d="M908.2,462.6v9h11.6v2h-11.6v10.9h-2.2v-23.8h14.5v2h-12.3Z"  />
          <path style="--index:21" class="cls-4" stroke="#000000" stroke-width="1" d="M932,484.5h-2.2v-10.2l-8.8-13.6h2.6l3.3,5.1c1.3,2.1,2.7,4.2,4,6.4h0c1.3-2.1,2.7-4.3,4-6.4l3.2-5.1h2.6l-8.8,13.6v10.2Z"  />
          <path style="--index:22" class="cls-4" stroke="#000000" stroke-width="1" d="M950.3,484.5v-23.8h2.2v23.8h-2.2Z"  />
          <path style="--index:23" class="cls-4" stroke="#000000" stroke-width="1" d="M979.8,484.5v-12.2c0-3.1,0-6.1,0-9.2h0c-1.2,3.1-2.4,6.2-3.6,9.3l-4.7,12.1h-2.5l-4.7-12.1c-1.2-3.1-2.4-6.1-3.6-9.3h0c0,3.1,0,6.1,0,9.2v12.2h-2.2v-23.8h3.5l4.7,12.2,3.5,9.3h0c1.2-3.1,2.4-6.2,3.6-9.3l4.7-12.2h3.5v23.8h-2.2Z"  />
          <path style="--index:24" class="cls-4" stroke="#000000" stroke-width="1" d="M995.7,460.7c5.3,0,8.1,2.7,8.1,6.9s-2.8,6.9-8.1,6.9h-5.6v9.9h-2.2v-23.8h7.7Zm-5.6,11.9h5.5c3.9,0,5.9-1.9,5.9-5s-2-4.9-5.9-4.9h-5.5v9.9Z"  />
          <path style="--index:25" class="cls-4" stroke="#000000" stroke-width="1" d="M1022.1,482.5v2h-14.8v-23.8h2.2v21.8h12.6Z"  />
          <path style="--index:26" class="cls-4" stroke="#000000" stroke-width="1" d="M1027.1,476.8l-3,7.7h-2.3l9.4-23.8h3l9.4,23.8h-2.3l-3-7.7h-11.2Zm9.4-4.5c-1.3-3.4-2.5-6.4-3.8-9.9h0c-1.3,3.4-2.5,6.5-3.8,9.9l-1,2.5h9.6l-.9-2.5Z"  />
          <path style="--index:27" class="cls-4" stroke="#000000" stroke-width="1" d="M1060.5,484.5l-6.2-10.6c-2.2-3.7-4.3-7.4-6.4-11.1h0c0,4,0,7.9,0,11.9v9.7h-2.2v-23.8h3.3l6.2,10.6c2.2,3.7,4.3,7.4,6.4,11.1h0c0-4,0-7.9,0-11.9v-9.7h2.2v23.8h-3.3Z"  />
          <path style="--index:28" class="cls-4" stroke="#000000" stroke-width="1" d="M1076.5,462.6v21.8h-2.2v-21.8h-8.5v-2h19.1v2h-8.5Z"  />
          <path style="--index:29" class="cls-4" stroke="#000000" stroke-width="1" d="M1101.6,460.7c7.7,0,12.2,4.3,12.2,11.9s-4.4,11.9-12.2,11.9h-6.9v-23.8h6.9Zm-4.8,21.8h4.8c6.3,0,9.9-3.5,9.9-9.9s-3.5-9.9-9.9-9.9h-4.8v19.8Z"  />
          <path style="--index:30" class="cls-4" stroke="#000000" stroke-width="1" d="M1120,462.6v8.6h12v2h-12v9.3h13v2h-15.2v-23.8h14.8v2h-12.6Z"  />
          <path style="--index:31" class="cls-4" stroke="#000000" stroke-width="1" d="M1152.2,484.5l-6.2-10.6c-2.2-3.7-4.3-7.4-6.4-11.1h0c0,4,0,7.9,0,11.9v9.7h-2.2v-23.8h3.3l6.2,10.6c2.2,3.7,4.3,7.4,6.4,11.1h0c0-4,0-7.9,0-11.9v-9.7h2.2v23.8h-3.3Z"  />
          <path style="--index:32" class="cls-4" stroke="#000000" stroke-width="1" d="M1168.2,462.6v21.8h-2.2v-21.8h-8.5v-2h19.1v2h-8.5Z"  />
          <path style="--index:33" class="cls-4" stroke="#000000" stroke-width="1" d="M1178.7,484.5v-23.8h2.2v23.8h-2.2Z"  />
          <path style="--index:34" class="cls-4" stroke="#000000" stroke-width="1" d="M1201.1,468.1h-2.2c0-4-2.2-5.8-6.1-5.8s-5.2,1.6-5.2,4.3,2,3.7,6,4.6c4.5,1.1,7.9,2.2,7.9,6.9s-3.1,6.8-8.1,6.8-8.5-2.8-8.5-8.4h2.2c0,4.4,2.5,6.3,6.3,6.3s5.9-1.7,5.9-4.7-2.2-3.7-6.3-4.8c-4.6-1.1-7.7-2.3-7.7-6.8s2.8-6.3,7.4-6.3,8.3,2.7,8.3,7.8Z"  />
          <path style="--index:35" class="cls-4" stroke="#000000" stroke-width="1" d="M1212,462.6v21.8h-2.2v-21.8h-8.5v-2h19.1v2h-8.5Z"  />
          <path style="--index:36" class="cls-4" stroke="#000000" stroke-width="1" d="M1229.6,460.7c5.6,0,8.2,2.4,8.2,6.3s-1.8,5.4-4.6,6h0c1.8,.6,2.5,1.6,3.5,4.5l2.5,6.9h-2.4l-2.3-6.6c-1-3-2.2-3.9-4.8-3.9h-4.9v10.5h-2.2v-23.8h7Zm-4.8,11.3h4.9c4,0,5.8-2.1,5.8-4.9,0-3-2.1-4.4-5.9-4.4h-4.8v9.4Z"  />
          <path style="--index:37" class="cls-4" stroke="#000000" stroke-width="1" d="M1249.1,484.5h-2.2v-10.2l-8.8-13.6h2.6l3.3,5.1c1.3,2.1,2.7,4.2,4,6.4h0c1.3-2.1,2.7-4.3,4-6.4l3.2-5.1h2.6l-8.8,13.6v10.2Z"  />
        </g>
      </svg>

      <!-- <img :src ="'img/logo-temp-home.jpg'"/> -->
      <!-- <img :src ="'img/hp-makeitsimple-logo.svg'"/> -->
      <!--
      <div class="mis-promo container text-center rel">
        <div>
          <h2
            ref="title"
            class="text-center hp-title"
            :class="[
              animateLogo || dirtyHome ? 'logo-in' : '',
              logoMove || dirtyHome ? 'logo-move' : '',
              logoReady || dirtyHome ? 'logo-ready' : '',
              animateLetters || dirtyHome ? 'next' : ''
            ]"
          >
            <logo class="with-slogan" animate @animation-end="logoTransitionEnd" />
            <span :class="['slogan-box','font-rg','pl-s','ml-s',animateLetters || dirtyHome ? 'animate' : '']"
              @transitionend="sloganTransitionEnd"
              id="logo-slogan"
              >MAKE IT SIMPLE</span
            >
          </h2>
          <h3
            :class="[
              'logo-extra',
              sloganReady || dirtyHome ? 'show' : '',
              'text-center',
              'text-gray-6'
            ]"
            v-text="localize('hp_our_mission')"
          ></h3>
        </div>
      </div>
      -->    

<!--         
        <div class="scrollnav">
          <span class="scBtn hpFont1" @click="scrollToSection('section_products')">Products</span>
          <span class="scSep">|</span>
          <span class="scBtn hpFont1" @click="scrollToSection('section_webinars')">Webinars</span>
          <span class="scSep">|</span>
          <span class="scBtn hpFont1" @click="scrollToSection('section_protips')">Pro Tips</span>
          <span class="scSep">|</span>
          <span class="scBtn hpFont1" @click="scrollToSection('section_blog')">Blog</span>
        </div>
        -->
      </div>
   </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
        test:''
    };
  },
  mounted() {
  },
  watch: {
    logoReady() {
      this.$nextTick(function() {
        let slogan = document.getElementById("logo-slogan");
        //alert("slogan.innerHTML="+slogan.innerHTML);
        slogan.innerHTML = slogan.textContent.replace(
          /\S/g,
          "<span class='scatter letter'>$&</span>"
        );

        this.animateLetters = true;

        setTimeout(
          function() {
            this.animateLetters = true;
          }.bind(this),
          0
        );
      });
    }    
  },
  computed: {
    ...mapState(["pageLayoutData", "locale", "dirtyHome"]),
  },
  methods: {

    getOffset(el) {
      const rect = el.getBoundingClientRect();
      return {
        left: rect.left + window.scrollX,
        top: rect.top + window.scrollY
      };
    },

    scrollToSection(sectionID)
    {
        let el = document.getElementById(sectionID);
        let offset = this.getOffset(el);
        if (el) {
          let top = offset.top - 150;
          window.scrollTo({ top, behavior: "smooth" });
        }
        //let targetElement = document.getElementById(sectionID);
        //targetElement.scrollIntoView({behavior: "smooth",block: "start"});
    },
    setLetters()
    {
        let slogan = document.getElementById("logo-slogan");
        slogan.innerHTML = slogan.textContent.replace(/\S/g,"<span class='scatter letter'>$&</span>");
        setTimeout(function() {this.animateLetters = true;}.bind(this),0);
    },
    logoTransitionEnd(e) {
      if (e.propertyName === "fill") {
        this.logoMove = true;
      } else if (e.propertyName === "left") {
        this.logoReady = true;
        this.setLetters();
      }
    },    
    sloganTransitionEnd: _.debounce(
      function() {
        // console.log("Slogan transition ended...");
        setTimeout(
          function() {
            this.sloganReady = true;
            this.dirtifyHome(true);
          }.bind(this),
          300
        );
      },
      600,
      { leading: true }
    ),
  }
};
</script>

<style scoped>
    .hptFlexEl
    {
      height: auto;
      margin: auto;
    }
    .scrollnav
    {
      color:#000;
      clear: both;
      display: block;
      margin: auto;
      text-align: center;
      width: 100%;
      position: relative;
      top: 15px;
      height: 40px;
      /* border: solid 2px red; */
    }
    .scBtn
    {
      padding: 5px 8px;
      border: solid 1px #8a8585;     
      color:#645f5f;      
      border-radius: 4px;
      min-width: 80px;
      display: inline-block;
      font-weight: 400 !important;
      margin: 0px 5px;
      transition: all ease 0.3s;
    }
    .scBtn:hover
    {
      cursor: pointer;
      border: solid 1px #0e6aa9;  
      background-color: #0e6aa9;   
      color:#fff;
    }
    .scSep
    {
      display: none;
      padding: 0px 10px;
      font-size: 10px;
    }

    .___cls-4{fill:#1d1d1b;}
    .cls-4
    {
      fill-opacity: 1;
      stroke-opacity: 0;
/*       stroke-dasharray: 1000;
      stroke-dashoffset: 1000;      
 */      animation: dash 0.8s linear forwards;
      animation-delay: calc(var(--index) * 0.02s);
      clip-path: circle(0%);
      
    }
    @keyframes dash {
      to {
        clip-path: circle(100%);
        fill-opacity: 1;
/*         stroke-opacity: 0;
        stroke-dashoffset: 0;
 */      }
    }

    .hpText svg
    {
      width: 32vw;
      max-width: 700px;
      height: auto;
      margin: auto;   
    }
    
    .cls-1{fill-rule:evenodd;}
    .cls-1,
    .cls-2{fill:#006eb8;}
    .cls-3{fill:none;stroke:#006eb8;stroke-miterlimit:10;stroke-width:3px;}
    
    .hpText
    {
        clear: both;
        width: 80vw;        
        margin: auto;
        height: 25vh;
        min-height: 190px;
        overflow: hidden;   
        text-align: center;     
        display: flex;
        align-content: center;
        flex-direction: column;
    }
    .hpText img
    {
      width: 35vw;
      max-width: 700px;
      height: auto;
      margin: auto;
    }
    .htp-grid
    {
      display: flex;
      flex-direction: row;
      column-gap: 3vw;
      width: 100%;
      height: auto;
      color: #000;
      align-items: stretch;
    }
    .hpt-col
    {
      flex: 1;
      text-align: left;
      /* border: solid 2px red; */
    }
    .htp-grid .hpt-left
    {
    }
    .htp-grid .hpt-right
    {
    }
    .hpText .hpSlogen 
    {
      color: #0068aa;
      overflow: hidden;
      display: inline-block; 
      padding-bottom: 30px;
    }
    .hpText .hpSlogen svg
    {
      padding-right: 15px;
      width: 7.5vw;
      height: auto;
    }
    .hpText .hpSlogen span
    {
      border-left: 1px solid #0068aa;
      font-weight: 300 !important;
      font-size: clamp(2vw,2.4vw,3rem);
      color: #0068aa;
      letter-spacing: -1px;      
      padding-left: 15px;
    }


    .hpText h1
    {
        font-weight: 400 !important;
        font-size: clamp(2vw,2.8vw,4.5rem);
        line-height: clamp(2vw,2.8vw,4.5rem);
        color: #424242;
        text-align: left;
    }
    .hpText h2
    {        
        font-size:clamp(1rem,1.7vw,3rem);
        line-height:clamp(1rem,calc(1.7vw + 10px),3rem);
        font-weight: 200 !important;
        color: #424242;
    }

</style>
